import React from 'react';
import PropTypes from 'prop-types';
import PagePage from 'components/PagePage';

function Page({ pathContext }) {
  return <PagePage data={pathContext} />;
}

Page.propTypes = {
  pathContext: PropTypes.shape({}).isRequired,
};

export default Page;



// WEBPACK FOOTER //
// ./src/templates/Page.js